<script lang="ts">
  import type { Errors } from "@shared/types/Errors";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  export let errors: Errors = { messages: [] };
  export let extraAttrs = {};

  function closeClick() {
    errors.messages = [];
  }

</script>

<style>
  .look-like-fizz {
    background-color: #ffeeef;
    border-color: #cb2431;
    color: #1b1b1b;
  }

  :global(.fizz-close-button svg) {
    color: #848484;
  }

  :global(.fizz-close-button:hover svg) {
    color: inherit;
  }

</style>

{#if errors && errors.messages && errors.messages.length > 0}
  <div class="fizz-styles">
    <div class="flash-messages__wrapper">
      <div class="ng-animation slide-in-out w500" {...extraAttrs}>
        {#each errors.messages as message (message)}
          <div class="fizz-alert-error">
            <div class="fizz-icon-button-small fizz-close-button" on:click={closeClick}>
              <Icon type="X" width="16" height="16" />
            </div>
            <div>{@html message}</div>
          </div>
        {/each}
      </div>
    </div>
  </div>
{/if}
